/**
 * Athos `pagination.totalResults` includes injected merchandising banners.
 * Subtract those so the count matches the product cards on the grid.
 */
export function calculateProductCount(results) {
  const apiTotalResults = results?.pagination?.totalResults || 0
  const content = results?.merchandising?.content || {}
  const totalBanners =
    (content.inline?.length || 0) +
    (content.header?.length || 0) +
    (content.footer?.length || 0) +
    (content.banner?.length || 0)

  return Math.max(0, apiTotalResults - totalBanners)
}
